import axiosJava from "@/api/config_java";
export const authList = param =>
  axiosJava.get(`/am/api/authorize/list`, { params: param });

export const authListAuthorize = (param) =>
  axiosJava.post(`/am/api/authorize/authorize?${param}`);